/**
 * api/partners.js — Partners CRUD
 *
 * GET    /api/partners
 * POST   /api/partners
 * PUT    /api/partners/:id
 * DELETE /api/partners/:id
 */

import client from './client';

export const partnersApi = {

  async getAll(params = {}) {
    const { data } = await client.get('/partners', { params });
    return data.data ?? data;
  },

  async create(payload) {
    const { data } = await client.post('/partners', payload);
    return data.data ?? data;
  },

  async update(id, payload) {
    const { data } = await client.put(`/partners/${id}`, payload);
    return data.data ?? data;
  },

  async remove(id) {
    await client.delete(`/partners/${id}`);
  },
};
